
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import global from "../../../static/js/global.js";
import loadPage from "../../components/loadingPage";
import $ from "jquery";
import XInput from "vux/src/components/x-input/index";
export default {
components: {
XInput,
PopupPicker,
Group,
XButton,
Flexbox,
FlexboxItem,
Alert,
Confirm,
loadPage,
$,
Datetime
},
data() {
return {
show_1: true,
};
},

mounted: function(){
this.code = this.$router.history.current.query.code;
this.state = this.$router.history.current.query.state;
let url =  global.host + 'users/getuser?code='+this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
console.log(url)
this.$http.get(url).then(function(res){
console.log(res)
if(res.body.result){
this.$router.replace({path:'/zhiF',query:{comnCode:this.state,openid:res.body.result.openId,phone:res.body.result.mainPhone}})
}else{

this.$router.replace({path:'/defeated'})
}
},function(err){
console.log(err);
})
},
}



// WEBPACK FOOTER //
// ./src/components/carRentComponents/weChatScaner.vue